export const Types = {
  GET_TASK_HISTORY_REQUEST: 'GET_TASK_HISTORY_REQUEST',
  RESET_TASK_HISTORY: 'RESET_TASK_HISTORY',
  GET_TASK_HISTORY_SUCCESS: 'GET_TASK_HISTORY_SUCCESS',
  SET_ERROR: 'SET_ERROR',
};

export const taskHistoryRequest = (FisNo) => ({
  type: Types.GET_TASK_HISTORY_REQUEST,
  FisNo,
});

export const taskHistoryReset = () => ({
  type: Types.RESET_TASK_HISTORY,
});


export const taskHistorySuccess = (response) => ({
  type: Types.GET_TASK_HISTORY_SUCCESS,
  payload: response,
});

export const setError = (error) => ({
  type: Types.SET_ERROR,
  payload: { error }
});
